import React, { useEffect, useState } from 'react';
import { api } from '../../App';

const gbp = (n) => `£${Number(n || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function FoundingSavingsWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/providers/me/beta-savings').then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data) return null;
  const rate = Math.round((data.standard_rate || 0) * 100);

  return (
    <div className="mt-3 pt-3 border-t border-[#D4AF37]/20 flex flex-wrap items-end gap-x-8 gap-y-2" data-testid="founding-savings-widget">
      <div>
        <p className="text-[11px] uppercase tracking-[0.18em] text-stone-500">Saved vs standard pricing</p>
        <p className="font-heading text-2xl text-[#1A1A1A]" data-testid="founding-savings-amount">{gbp(data.commission_saved)}</p>
      </div>
      <p className="text-xs text-stone-500 max-w-sm leading-relaxed" data-testid="founding-savings-explainer">
        {data.paid_bookings > 0
          ? `Across ${data.paid_bookings} paid booking${data.paid_bookings === 1 ? '' : 's'} (${gbp(data.gross_takings)}), this is what beta pricing has saved you compared with the standard ${rate}% commission plus processing on new marketplace clients after beta.`
          : `Your first paid booking will start the count. After beta, new marketplace clients carry a ${rate}% commission plus processing.`}
      </p>
    </div>
  );
}
